// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

type PaymentInfoProps = {
  label: string,
  children: string | Node,
  subLabel: string,
  location: string,
  redesign: boolean,
}

export function PaymentInfo({label, children, subLabel, location, redesign}: PaymentInfoProps): Node {
  return (
    <PaymentInfoItem location={location} redesign={redesign}>
      <PaymentInfoItemLabel redesign={redesign}>{label}</PaymentInfoItemLabel>
      <PaymentInfoItemValue>{children}</PaymentInfoItemValue>
      <PaymentInfoSubLabel><BlueHighlight>{subLabel}</BlueHighlight></PaymentInfoSubLabel>
    </PaymentInfoItem>
  );
}

const PaymentInfoItem = styled.dl`
  font-family: ${props => props.theme.fontFamily.display};
  color: ${props => props.redesign !== false ? props.theme.colors.secondaryGray : props.theme.colors.secondary(30)};
  display: flex;
  ${props => props.redesign !== false ? 'flex: 1' : ''};
  flex-direction: column;
  line-height: 1;
  justify-content: space-around;
  flex-grow: 1;
  ${props => props.redesign === false ? 'align-items: flex-start' : 'padding: 1em'};
  ${props => props.redesign === false ? 'margin-right: 2em' : ''};
  ${props => props.location === 'left' ? 'border-right: 1px solid hsl(210, 17%, 88%)' : ''};
`;

const PaymentInfoItemLabel = styled.dt`
  font-size: 15px;
  font-weight: 300;
  color: ${props => props.redesign !== false ? props.theme.colors.secondaryGray : props.theme.colors.black};
  margin-bottom: 0.2em;
`;

const PaymentInfoSubLabel = styled.dt`
  font-size: 10px;
  font-weight: 300;
  color: ${props => props.theme.colors.secondaryGray};
  ${props => props.redesign !== false ? 'margin-bottom: 0.2em' : ''}
`;

const BlueHighlight = styled.span`
  background-color: hsl(201, 72%, 48%, 0.15);
`;

const PaymentInfoItemValue = styled.dd`
  font-size: 20px;
  font-weight: 800;
  color: ${props => props.redesign !== false ? props.theme.colors.secondaryGray : props.theme.colors.black};
  text-align: baseline;
`;
